import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate for navigation
import "./EmployeeHomepage.css";
import {FaEye ,FaEyeSlash } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import DeleteCustomerPopup from "./DeleteCustomerPopup";
import { set } from "react-hook-form";
import Breadcrumb from "../utils/BreadCrumbs";
import { FaChevronDown } from "react-icons/fa";
import {simulationService} from "../../services/api/simulationService";
import { PYTHON_API_BASE_URL } from "../../services/api/apiConstants";
import { useNavigation } from "../../contexts/NavigationContext";
import {
  DELETE_SUCCESS,
  OWNS_MICROGRIDS,
  formatDeleteUserError,
  parseDeleteUserError,
} from "../../features/users/domain/deleteUserError";
import { emailQuery } from "../../features/users/domain/emailQuery";
import { customerByEmailQuery } from "../../features/users/domain/customerByEmailQuery";

const EmployeeHomepage = () => {
  const [customers, setCustomers] = useState([]);
  const [showNewcustomer, setShowNewcustomer] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isDeleting, setIsDeleting] = useState(false);
  const [activeTab, setActiveTab] = useState("customers");
  const navigate = useNavigate();
  const token = sessionStorage.getItem("accessToken");
  const { setSelectedCustomer: setNavCustomer, setStorageAccountName: setNavStorageAccount, selectedBranchId, setSelectedBranch } = useNavigation();
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [refreshCustomers, setRefreshCustomers] = useState(false); // NEW
  const [isDeletePopupVisible, setIsDeletePopupVisible] = useState(false);
  const [customerloading, setCustomerLoading] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  // The branch id Edit loaded selectedCustomer with; Save sends this one, not
  // the branch selected at save time (ADM-66). null when none was sent.
  const [editBranchId, setEditBranchId] = useState(null);
  const [isEditingLoading, setIsEditingLoading] = useState(false);
  const jobTitle = sessionStorage.getItem("jobTitle");
  const [Branches, setBranches] = useState([]);
  const [isBranchLoaded, setIsBranchLoaded] = useState(false);
  const [formData, setFormData] = useState({
    addressLine: "",
    city: "",
    state: "",
    country: "US",
    zipCode: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
    utilityCompanyName: "",
    utilityAccountNumber:""
  });
  const placeholders = {
    US: "Ex. 231 221 1299",
    IN: "Ex. 98765 43210",
    UK: "Ex. 07123 456789",
  };

  const [isStateDropdownOpen, setIsStateDropdownOpen] = useState(false);
  const usStates = [
    { name: 'Alabama', abbr: 'Alabama' },
    { name: 'Alaska', abbr: 'Alaska' },
    { name: 'Arizona', abbr: 'Arizona' },
    { name: 'Arkansas', abbr: 'Arkansas' },
    { name: 'California', abbr: 'California' },
    { name: 'Colorado', abbr: 'Colorado' },
    { name: 'Connecticut', abbr: 'Connecticut' },
    { name: 'Delaware', abbr: 'Delaware' },
    { name: 'Florida', abbr: 'Florida' },
    { name: 'Georgia', abbr: 'Georgia' },
    { name: 'Hawaii', abbr: 'Hawaii' },
    { name: 'Idaho', abbr: 'Idaa' },
    { name: 'Illinois', abbr: 'Illinois' },
    { name: 'Indiana', abbr: 'Indiana' },
    { name: 'Iowa', abbr: 'Iowa' },
    { name: 'Kansas', abbr: 'Kansas' },
    { name: 'Kentucky', abbr: 'Kentucky' },
    { name: 'Louisiana', abbr: 'Louisiana' },
    { name: 'Maine', abbr: 'Maine' },
    { name: 'Maryland', abbr: 'Maryland' },
    { name: 'Massachusetts', abbr: 'Massachusetts' },
    { name: 'Michigan', abbr: 'Michigan' },
    { name: 'Minnesota', abbr: 'Minnesota' },
    { name: 'Mississippi', abbr: 'Mississippi' },
    { name: 'Missouri', abbr: 'Missouri' },
    { name: 'Montana', abbr: 'Montana' },
    { name: 'Nebraska', abbr: 'Nebraska' },
    { name: 'Nevada', abbr: 'Nevada' },
    { name: 'New Hampshire', abbr: 'New Hampshire' },
    { name: 'New Jersey', abbr: 'New Jersey' },
    { name: 'New Mexico', abbr: 'New Mexico' },
    { name: 'New York', abbr: 'New York' },
    { name: 'North Carolina', abbr: 'North Carolina' },
    { name: 'North Dakota', abbr: 'North Dakota' },
    { name: 'Ohio', abbr: 'Ohio' },
    { name: 'Oklahoma', abbr: 'Oklahoma' },
    { name: 'Oregon', abbr: 'Oregon' },
    { name: 'Pennsylvania', abbr: 'Pennsylvania' },
    { name: 'Rhode Island', abbr: 'Rhode Island' },
    { name: 'South Carolina', abbr: 'South Carolina' },
    { name: 'South Dakota', abbr: 'South Dakota' },
    { name: 'Tennessee', abbr: 'Tennessee' },
    { name: 'Texas', abbr: 'Texas' },
    { name: 'Utah', abbr: 'Utah' },
    { name: 'Vermont', abbr: 'Vermont' },
    { name: 'Virginia', abbr: 'Virginia' },
    { name: 'Washington', abbr: 'Washington' },
    { name: 'West Virginia', abbr: 'West Virginia' },
    { name: 'Wisconsin', abbr: 'Wisconsin' },
    { name: 'Wyoming', abbr: 'Wyoming' }
  ];
  const toggleStateDropdown = () => {
    setIsStateDropdownOpen(!isStateDropdownOpen);
  };
  const handleStateSelect = (abbr) => {
    // This calls your main handleChange logic
    handleChange({
        target: {
            name: 'state',
            value: abbr
        }
    });
    // Close the dropdown after selection
    setIsStateDropdownOpen(false);
  };
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  // Fetch branch details from employee email
  useEffect(() => {
    const fetchBranchdetailsFromEmployeeEmail = async () => {
      try {
        const employeeEmail = sessionStorage.getItem('employeeEmail');
        const email = employeeEmail || sessionStorage.getItem('email') || '';
        const API_URL = `${PYTHON_API_BASE_URL}/branch-by-employee-email/`;
        const token = sessionStorage.getItem("accessToken");

        if (!token) return;

        const response = await fetch(API_URL, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "X-User-ID": sessionStorage.getItem("UserID") || "",
          },
        });

        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

        const data = await response.json();
        setIsBranchLoaded(true);
        setBranches(data || []);
        // console.log(data,"dat afrom branches");
        if (data) {
          setSelectedBranch({ id: data.id, branch_name: data.branch_name, admin_email: data.admin_email, address: data.address });
        }
      } catch (error) {
        console.error("Error fetching branches:", error);
      }
    };

    const token = sessionStorage.getItem("accessToken");
    if (token) {
      fetchBranchdetailsFromEmployeeEmail();
    }
  }, []);

  // Fetch customers only after branchId is set
  useEffect(() => {
    const fetchCustomers = async () => {
      const token = sessionStorage.getItem("accessToken");
      if (!token || !selectedBranchId) return;

      setLoading(true);

      const API_URL = `${PYTHON_API_BASE_URL}/customers/by-branch/?branch_id=${selectedBranchId}`;

      try {
        const response = await fetch(API_URL, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "X-User-ID": sessionStorage.getItem("UserID") || "",
          },
        });

        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

        const data = await response.json();
        setCustomers(data.customers || []);
      } catch (error) {
        console.error("Error fetching customers:", error);
      } finally {
        setLoading(false);
      }
    };
    // Fetch customers only when branchId exists or refreshCustomers changes
    if (selectedBranchId) {
      fetchCustomers();
    }

  }, [refreshCustomers, isBranchLoaded]); // depends on branch load

  const validateFields = async() => {
  const newErrors = {};
  let isValid = true;

    
  if (!formData.addressLine) {
    newErrors.addressLine = "Address line is required";
    isValid = false;
  } else if (formData.addressLine.length > 50) {
    newErrors.addressLine = "Address line must not exceed 50 characters";
    isValid = false;
  }
    if (!formData.city) {
      newErrors.city = "City is required";
      isValid = false;
    }
    if (!formData.state) {
      newErrors.state = "State is required";
      isValid = false;
    }
    
    if (!formData.zipCode) {
      newErrors.zipCode = "Zip code is required";
      isValid = false;
    }
    else if (!/^\d{5}$/.test(formData.zipCode)) {
      newErrors.zipCode = "Zip code must be exactly 5 digits";
      isValid = false;
    }
    if (!formData.firstName) {
      newErrors.firstName = "First name is required";
      isValid = false;
    } else if (!/^[a-zA-Z\s'-]{1,50}$/.test(formData.firstName)) {
      newErrors.firstName = "First name can only contain letters, spaces, hyphens, or apostrophes (max 50 characters).";
      isValid = false;
    }
    if (!formData.lastName) {
      newErrors.lastName = "Last name is required";
      isValid = false;
    } else if (!/^[a-zA-Z\s'-]{1,50}$/.test(formData.lastName)) {
      newErrors.lastName = "Last name can only contain letters, spaces, hyphens, or apostrophes";
      isValid = false;
    }
    if (!selectedCustomer) {
      if (!formData.email) {
        newErrors.email = "Email is required";
        isValid = false;
      } else if ( !/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(formData.email)) {
        newErrors.email = "Invalid email format.";
        isValid = false;
      } else if (formData.email.length > 256) {
        newErrors.email = "Email cannot exceed 256 characters.";
        isValid = false;
      }
    }
    if (!formData.phone) {
      newErrors.phone = "Phone number is required";
      isValid = false;
    } else if (!/^\d{10}$/.test(formData.phone)) {
      newErrors.phone = "US phone number must be 10 digits.";
      isValid = false;
    }
    if (!selectedCustomer) {
      if (!formData.password) {
        newErrors.password = "Password is required";
        isValid = false;
      } else if (
        !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(
          formData.password
        )
      ) {
        newErrors.password =
          "Password must be at least 8 characters long and include an uppercase letter, a lowercase letter, a number, and a special character.";
        isValid = false;
      }
      if (!formData.confirmPassword) {
        newErrors.confirmPassword = "Confirm password is required";
        isValid = false;
      }
      if (formData.password !== formData.confirmPassword) {
        newErrors.confirmPassword = "Passwords do not match";
        isValid = false;
      }
    }
    if (!formData.utilityCompanyName) {
      newErrors.utilityCompanyName = "Utility company name  is required";
      isValid = false;
    } else if (formData.utilityCompanyName.length > 50) {
      newErrors.utilityCompanyName = "Utility company name must not exceed 50 characters";
      isValid = false;
    }
    if (!formData.utilityAccountNumber) {
      newErrors.utilityAccountNumber = "Utility account number is required";
      isValid = false;
    } else if (formData.utilityAccountNumber.length > 10) {
      newErrors.utilityAccountNumber = "Utility account number must not exceed 10 characters";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  }

  // Handle customer registration
  const handleRegister = async (e) => {
    const isFormValid = await validateFields();
    e.preventDefault();
    if (!isFormValid) {
      return;
    }
    setLoading(true);
             
    try {
      const token = sessionStorage.getItem("accessToken");
      const apiUrl = selectedCustomer
        ? `${PYTHON_API_BASE_URL}/customers/update/?${customerByEmailQuery(selectedCustomer.email, editBranchId)}` // Update API
        : `${PYTHON_API_BASE_URL}/customers/create/`; // Create API

      const method = selectedCustomer ? "PUT" : "POST"; 
      const response = await fetch(
        apiUrl,
        {
          method: method,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            "X-User-ID": sessionStorage.getItem("UserID") || "",
          },
          body: JSON.stringify({
            first_name: formData.firstName,
            last_name: formData.lastName,
            email: formData.email,
            password: formData.password,
            phone:formData.phone,
            city: formData.city,
            state: formData.state,
            country: formData.country,
            zip_code: formData.zipCode,
            address_line: formData.addressLine,
            utility_company_name: formData.utilityCompanyName,
            utility_account_number: formData.utilityAccountNumber,
            employee:sessionStorage.getItem("UserID"),
            branch_id: selectedBranchId
            // include any other fields required by your OrganizationSignupView
          }),
        }
      );
              
      // Parse response first
      const data = await response.json();
                
      // Check if response is not successful
      if (!response.ok) {
        const errorMsg = data.error || `Failed with status: ${response.status}`;
        setError(errorMsg);
        toast.error(errorMsg);
        return;
      }

      // console.log("✅ Customer created:", data);
      toast.success(selectedCustomer ? "Customer updated successfully" : "Customer created successfully");
      // You can store orgId in sessionStorage for later use
      setRefreshCustomers(((prev) => prev + 1));
                
      setShowNewcustomer(false);
      setFormData({
        addressLine: "",
        city: "",
        state: "",
        country: "US",
        zipCode: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        password: "",
        confirmPassword: "",
        utilityCompanyName: "",
        utilityAccountNumber:""
        // include any other fields you have in your form
      });
      // Trigger refresh
               
    } catch (error) {
        console.error("Error in handleRegister:", error);
        setError("Failed to register customer. Please try again.");
        toast.error("Failed to register customer. Please try again.");
      } finally {
        setLoading(false);
      }
  };

  // Handle customer edit
  const handleEdit = async (employee, e) => {
 

  // Open popup immediately
  setShowNewcustomer(true);
  setCustomerLoading(true); 

  const token = sessionStorage.getItem("accessToken");
  try {
    const response = await fetch(
      `${PYTHON_API_BASE_URL}/getCustomer-by-Email/?${customerByEmailQuery(employee.email, selectedBranchId)}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          "X-User-ID": sessionStorage.getItem("UserID") || "",
        },
      }
    );

    const data = await response.json();

    setSelectedCustomer(data);
    setEditBranchId(selectedBranchId);
    setFormData({
      firstName: data.first_name,
      lastName: data.last_name,
      email: data.email,
      phone: data.phone,
      password: data.password,
      confirmPassword: data.password,
      city: data.address?.city || "",
      state: data.address?.state || "",
      country: (data.address?.country === "United States" ? "US" : data.address?.country) || "US",
      zipCode: data.address?.zip_code || "",
      addressLine: data.address?.address_line || "",
      utilityCompanyName: data.utility_company_name || "",
      utilityAccountNumber: data.utility_account_number || ""
    });
  } catch (error) {
    console.error("Error fetching employee details:", error);
    alert("Failed to load employee details.");
  } finally {
    setCustomerLoading(false); // hide loader after data loads
  }
};

const handleClosePopup = () => {
    
    setIsDeletePopupVisible(false);
  
  };

  // Row click handler
  const handleRowClick = async (customer) => {
    setIsEditingLoading(true);
    // Update navigation context (triggers sidenav progressive disclosure)
    setNavCustomer(customer.email, customer.first_name);
    try{
      await fetchStorageAccountName(selectedBranchId);
      navigate("/microgrid-page-design");
    }
    catch (error) {
        // Optional: Handle any unexpected errors that might bubble up
        console.error("Navigation failed after fetch:", error);
    } finally {
        // 4. STOP LOADER regardless of success or failure
        setIsEditingLoading(false); // Stop the loading state
    }
  };
  // Fetch storage account name
  const fetchStorageAccountName = async (branchId) => {
    const API_URL = `${PYTHON_API_BASE_URL}/storage-account/?branch_id=${branchId}`;

    try {
      const response = await fetch(API_URL, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "X-User-ID": sessionStorage.getItem("UserID") || "",
        },
      });

      if (!response.ok)
        throw new Error("Failed to fetch storage account name.");

      const data = await response.json();
      setNavStorageAccount(data.storage_account.storage_account_name);
      
    } catch (error) {
      
    }
  };

  
  // Handle close popup
  const handleClose = (e) => {
    e.preventDefault();
    setShowNewcustomer(false);
    setIsStateDropdownOpen(false);
    setErrors("");
    setErrors({});
    setFormData({
    addressLine: "",
    city: "",
    state: "",
    country: "US",
    zipCode: "",
    // phoneCountry: "US",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
    utilityCompanyName: "",
    utilityAccountNumber:""
    })
    setSelectedCustomer(null);
    setEditBranchId(null);
    setError("");
  };

  const handleDelete = async (employee) => {
    setSelectedCustomer(employee);
    setTimeout(() => setIsDeletePopupVisible(true), 50);
  };

  const handleConfirmDelete = async () => {
      if (!selectedCustomer || !selectedCustomer.email) {
        console.error("No employee selected or email missing.");
        return;
      }
     setIsDeleting(true);
      try {
        const response= await fetch(
          `${PYTHON_API_BASE_URL}/customers/delete/?${emailQuery(selectedCustomer.email)}`,
          {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
              "X-User-ID": sessionStorage.getItem("UserID") || "",
            },
          }
        );
        if (!response.ok) {
          const body = await response.json().catch(() => null);
          const failure = parseDeleteUserError({ status: response.status, body });
          console.error("Delete failed:", response.status, failure.kind);
          toast.error(
            formatDeleteUserError(failure),
            failure.kind === OWNS_MICROGRIDS ? { autoClose: false } : undefined
          );
          return;
        }
        // console.log("Employee deleted successfully.");
        setRefreshCustomers((prev) => prev + 1);
        toast.success(DELETE_SUCCESS.customer);

      } catch {
        const failure = parseDeleteUserError({ networkError: true });
        console.error("Delete failed:", failure.kind);
        toast.error(formatDeleteUserError(failure));
      }
      finally
      {
        setIsDeletePopupVisible(false);
        setSelectedCustomer(null);
        setEditBranchId(null);
        setIsDeleting(false);
      }
    };

  
const breadcrumbItems = !isBranchLoaded
  ? [
      // Show skeleton placeholders
      { label: <div className="skeleton skeleton-heading"></div> },
      
    ]
  : jobTitle === "Branch Admin"
  ? [
      { label: "Employees", path: "/employees" },
      { label: "Customers" },
    ]
  : [
      {
        label: `${Branches.branch_name} - Customers`,
      },
    ];




  return (

    <div className="employee-main">

      <h2 className="page-heading">
        {/* Show skeleton placeholders */}
        {!isBranchLoaded ? (
          // Show skeleton placeholders
          <div className="skeleton skeleton-heading"></div>
        ) : (
          // Show branch name and city
          `${Branches.branch_name} - ${Branches.city}`
        )}

      </h2>

      <Breadcrumb items={breadcrumbItems} />

      {/* Show button container */}
      <div className="button-container">

        <button
          className="add-device-save-button"
          onClick={() => {
            setSelectedCustomer(null);
            setEditBranchId(null);
            setIsStateDropdownOpen(false);
            setFormData({
              addressLine: "",
              city: "",
              state: "",
              country: "US",
              zipCode: "",
              // phoneCountry: "US",
              firstName: "",
              lastName: "",
              email: "",
              phone: "",
              password: "",
              confirmPassword: "",
              utilityCompanyName: "",
              utilityAccountNumber: ""
            });
            setShowNewcustomer(true);
          }}
        >
          + New Customer
        </button>
      </div>
              
      {showNewcustomer && (
        // Show customer registration popup
        <div className="popup-overlay-customer">
          <div className="customer-register-form-container">
            <button
              className="popup-customer-close-button"
              onClick={handleClose}
            >
              ✕
            </button>

            {customerloading || loading ? (
              <div className="spinner-container-micro" style={{ margin: "50px auto" }}>
                <div className="spinner-micro" />
              </div>
            ) : (
              <form className="customer-register-form" onSubmit={handleSubmit}>
                <h2>{selectedCustomer ? "Edit Customer" : "New Customer Registration"}</h2>

                <h3>Customer Information</h3>
                <p style={{ color: "#4A5568" }}>
                  Please fill out the required information to {selectedCustomer ? "edit" : "register"} the customer
                </p>

                {/* Name Fields */}
                <div className="form-row-customer">
                  <div className="form-group-customer">
                    <label>First Name <span className="required-asterisk">*</span></label>
                    <input
                      type="text"
                      name="firstName"
                      placeholder="Ex. John"
                      value={formData.firstName}
                      onChange={handleChange}
                    />
                    {errors.firstName && <span className="add-device-error-message">{errors.firstName}</span>}
                  </div>

                  <div className="form-group-customer">
                    <label>Last Name <span className="required-asterisk">*</span></label>
                    <input
                      type="text"
                      name="lastName"
                      placeholder="Ex. Doe"
                      value={formData.lastName}
                      onChange={handleChange}
                    />
                    {errors.lastName && <span className="add-device-error-message">{errors.lastName}</span>}
                  </div>
                </div>

                {/* Email and Contact */}
                <div className="form-row-customer">
                  {!selectedCustomer && (
                    <div className="form-group-customer">
                      <label>Email <span className="required-asterisk">*</span></label>
                      <input
                        type="email"
                        name="email"
                        placeholder="Ex. john@whygrene.com"
                        value={formData.email}
                        onChange={handleChange}
                      />
                      {errors.email && <span className="add-device-error-message">{errors.email}</span>}
                    </div>
                  )}

                  <div className="form-group-customer">
                    <label>Contact No. <span className="required-asterisk">*</span></label>
                    <div className="combined-phone-input-container">
                      <select
                        name="phoneCountry"
                        value={formData.phoneCountry}
                        onChange={handleChange}
                        className="phone-country-select"
                      >
                        <option value="US">US</option>
                      </select>
                      <input
                        type="text"
                        name="phone"
                        placeholder={"Ex. 1234567890"}
                        className="phone-number-input"
                        value={formData.phone}
                        onChange={handleChange}
                      />
                    </div>
                    {errors.phone && <span className="add-device-error-message">{errors.phone}</span>}
                  </div>
                </div>

                {/* Address Fields */}
                <div className="form-group-customer">
                  <label>Address Line <span className="required-asterisk">*</span></label>
                  <input
                    type="text"
                    name="addressLine"
                    placeholder="Enter Address Line 1"
                    value={formData.addressLine}
                    onChange={handleChange}
                  />
                  {errors.addressLine && <span className="add-device-error-message">{errors.addressLine}</span>}
                </div>

                <div className="form-row-customer">
                  <div className="form-group-customer">
                    <label>City <span className="required-asterisk">*</span></label>
                  

                    <input
                  type="text"
                  name="city"
                  className="wide-input"
                  placeholder="Enter city"
                  value={formData.city}
                  onChange={handleChange}
                  
                />
                    {errors.city && <span className="add-device-error-message">{errors.city}</span>}
                  </div>

                  <div className="form-group-customer">
                    <label>State <span className="required-asterisk">*</span></label>
        
        <div className="custom-select-wrapper-state">
            
            {/* ➡️ MODIFIED: Added a wrapper div for the content and icon */}
            <div 
                className="custom-select-display" 
                onClick={toggleStateDropdown}
            >
                {/* Content (State Name) */}
                <span className="select-display-text">
                  {usStates.find(s => s.abbr === formData.state)?.name || "--Select a State--"}
                </span>
                
                {/* ➡️ ICON PLACEMENT: Use the new icon and apply a class for styling */}
                <FaChevronDown 
                    className={`select-caret-icon ${isStateDropdownOpen ? 'rotated' : ''}`}
                />
            </div>

            
          {isStateDropdownOpen && (
                <ul className="custom-options-list-state">
                  
                    <li className="disabled-option">
                --Select a State--
            </li>
                    {usStates.map(state => (
                        <li 
                            key={state.abbr} 
                            onClick={() => handleStateSelect(state.abbr)}
                            className={formData.state === state.abbr ? 'selected' : ''}
                        >
                            {state.name}
                        </li>
                    ))}
                </ul>
            )}
        </div>
                    {errors.state && <span className="add-device-error-message">{errors.state}</span>}
                  </div>
                </div>

                <div className="form-row-customer">
                  <div className="form-group-customer">
                    <label>Country <span className="required-asterisk">*</span></label>
                    <select
                      name="country"
                      value={formData.country}
                      onChange={handleChange}
                  >
                    {/* <option value="">----Select a Country----</option> */}
                    <option value="US">United States</option>
                      
                    </select>
                    {errors.country && <span className="add-device-error-message">{errors.country}</span>}
                  </div>

                  <div className="form-group-customer">
                    <label>Zip Code <span className="required-asterisk">*</span></label>
                    <input
                      type="text"
                      name="zipCode"
                      placeholder="Zipcode"
                      value={formData.zipCode}
                      onChange={handleChange}
                    />
                    {errors.zipCode && <span className="add-device-error-message">{errors.zipCode}</span>}
                  </div>
                </div>

                {/* Password Fields */}
                <div className="form-row-customer">
                  {!selectedCustomer && (
                    <>
                      <div className="form-group-customer">
                        <label>Password <span className="required-asterisk">*</span></label>
                        <div className="input-with-icon">
                          <input
                            type={showPassword ? "text" : "password"}
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                          />
                          <span className="icon" onClick={() => setShowPassword(!showPassword)}>
                            <FaEye className={showPassword ? "icon-visible" : "icon-hidden"} />
                            <FaEyeSlash className={showPassword ? "icon-hidden" : "icon-visible"} />
                          </span>
                        </div>
                        {errors.password && <span className="add-device-error-message">{errors.password}</span>}
                      </div>

                      <div className="form-group-customer">
                        <label>Confirm Password <span className="required-asterisk">*</span></label>
                        <div className="input-with-icon">
                          <input
                            type={showConfirmPassword ? "text" : "password"}
                            name="confirmPassword"
                            value={formData.confirmPassword}
                            onChange={handleChange}
                          />
                          <span className="icon" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                            <FaEye className={showConfirmPassword ? "icon-visible" : "icon-hidden"} />
                            <FaEyeSlash className={showConfirmPassword ? "icon-hidden" : "icon-visible"} />
                          </span>
                        </div>
                        {errors.confirmPassword && <span className="add-device-error-message">{errors.confirmPassword}</span>}
                      </div>
                    </>
                  )}
                </div>

                {/* Utility Info */}
                <div className="form-row-customer">
                  <div className="form-group-customer">
                    <label>Utility Company Name <span className="required-asterisk">*</span></label>
                    <input
                      type="text"
                      name="utilityCompanyName"
                      placeholder="Ex. Puget Sound Energy"
                      value={formData.utilityCompanyName}
                      onChange={handleChange}
                    />
                    {errors.utilityCompanyName && <span className="add-device-error-message">{errors.utilityCompanyName}</span>}
                  </div>

                  <div className="form-group-customer">
                    <label>Utility Account Number <span className="required-asterisk">*</span></label>
                    <input
                      type="text"
                      name="utilityAccountNumber"
                      placeholder="Ex. 1234567890"
                      value={formData.utilityAccountNumber}
                      onChange={handleChange}
                    />
                    {errors.utilityAccountNumber && <span className="add-device-error-message">{errors.utilityAccountNumber}</span>}
                  </div>
                </div>

                {error && (
        <div className="error-message-box">
          {error}
        </div>
      )}


                {/* Submit Button */}
                <button
                  type="submit"
                  className="register-button"
                  onClick={handleRegister}
                  disabled={loading}
                >
                  {loading ? "Saving..." : selectedCustomer ? "Update" : "Register"}
                  {loading && <span className="spinner"></span>}
                </button>
              </form>
            )}
          </div>
        </div>
      )}

    {/* Show tabs */}
    <div className="tabs">
      {/* Show customers tab */}
        
        <button
          className={activeTab === "customers" ? "active" : ""}
          onClick={() => setActiveTab("customers")}
        >
          Customers 
        </button>
      </div>
      
      <div className="employee-table-container">
        {loading ? (
          <div className="spinner-container-customer">
            <div className="spinner-customer"></div>
          </div>
        ) : customers.length > 0 ? (
          <table className="table employee-customers-table">
            <thead>
              <tr>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {customers.map((customer) => (
                <tr
                  key={customer.id}
                  onClick={() => handleRowClick(customer)}
                  style={{ cursor: "pointer" }}
                >
                  <td>{customer.first_name}</td>
                  <td>{customer.last_name}</td>
                  <td>{customer.email}</td>
                  <td>
                    <i
                      className="fa fa-pencil edit-icon-employee"
                      aria-hidden="true"
                      title="Edit Customer"
                      onClick={(e)=>
                      {
                        e.stopPropagation();
                        handleEdit(customer);
                      }
                      }
                      
                    ></i>
                    <i
                      className="fa fa-trash delete-icon-employee"
                      aria-hidden="true"
                      title="Delete Customer"
                      onClick={(e)=>
                      {
                        e.stopPropagation();
                         handleDelete(customer);
                      }
                      }
                    ></i>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="no-data">No customers available</p>
        )}
      </div>

      {isDeletePopupVisible && (
          <DeleteCustomerPopup
            onClose={handleClosePopup}
            onDelete={handleConfirmDelete}
            selectedCustomer={selectedCustomer}
            isDeleting={isDeleting}
          />                   
        )}
    </div>
  );
};

export default EmployeeHomepage;
